export const PageHeader = ({ title, description, actions, eyebrow }) => (
  <div className='mb-6 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between'>
    <div>
      {eyebrow && (
        <p className='mb-2 text-xs font-semibold uppercase tracking-[0.16em] text-[var(--brand)]'>
          {eyebrow}
        </p>
      )}
      <h1 className='text-2xl font-bold text-[var(--text-primary)] lg:text-3xl'>{title}</h1>
      {description && (
        <p className='mt-2 max-w-3xl text-sm leading-6 text-[var(--text-secondary)]'>
          {description}
        </p>
      )}
    </div>
    {actions && <div className='flex flex-wrap items-center gap-3'>{actions}</div>}
  </div>
);
